import React from "react";
import { array, string, bool } from "prop-types";

import CustomStoryCard4 from "../../../molecules/CustomStoryCard4";

import "./organism2.m.css";

const Organism2 = ({ storyList, className, updatedFont = false }) => (
  <div styleName="base" className={className}>
    {storyList && storyList.length
      ? storyList
          .splice(0, 3)
          .map(({ story }, index) => (
            <CustomStoryCard4
              story={story}
              key={index}
              headlineType={21}
              widths={[300]}
              updatedFont={updatedFont}
              changeAspectRatio={global.deviceWidth > 875 ? [16, 9] : [4, 3]}
            />
          ))
      : null}
  </div>
);

Organism2.propTypes = {
  storyList: array.isRequired,
  className: string,
  updatedFont: bool,
};

export default Organism2;
